/*
 * Ki-Tax: System for the management of external childcare subsidies
 * Copyright (C) 2017 City of Bern Switzerland
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import {IHttpParamSerializer, IHttpService, ILogService, IPromise} from 'angular';
import TSReportTypeDTO from '../../models/TSReportTypeDTO';

/**
 * spricht die reportAsync resourec an welce die reports async generiert
 */
export class ReportAsyncRS {

    public static $inject = ['$httpParamSerializer', 'REST_API', '$log', '$http'];
    public serviceURL: string;
    public reportingTimeout: number = 240000;

    public constructor(
        public httpParamSerializer: IHttpParamSerializer,
        REST_API: string,
        public log: ILogService,
        public http: IHttpService,
    ) {
        this.serviceURL = `${REST_API}reporting/async`;
    }

    public getReport(reportDTO: TSReportTypeDTO): IPromise<string> {
        let reportTypeDTOToSend = {};
        reportTypeDTOToSend = reportDTO.serialize(reportTypeDTOToSend);

        return this.http.put(`${this.serviceURL}/statistik/report`,
            reportTypeDTOToSend,
            {
                timeout: this.reportingTimeout,
                headers: {
                    'Content-Type': 'application/json'
                }})
            .then((response: any) => {
                this.log.debug('Queued Job returned ', response.data);
                return response.data;
            });

    }

    public getServiceName(): string {
        return 'ReportAsyncRS';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/reportAsyncRS.rest.ts